export type DuePreset = 'today' | 'tomorrow' | 'three-days'

function atLocalHour(date: Date, hour: number): Date {
  const next = new Date(date)
  next.setHours(hour, 0, 0, 0)
  return next
}

export function dueForPreset(preset: DuePreset, now = new Date()): Date {
  if (preset === 'today') {
    const endOfWorkday = atLocalHour(now, 17)
    return endOfWorkday.getTime() > now.getTime() ? endOfWorkday : new Date(now.getTime() + 60 * 60 * 1000)
  }
  const days = preset === 'tomorrow' ? 1 : 3
  const due = atLocalHour(now, 9)
  due.setDate(due.getDate() + days)
  return due
}

export function toDateTimeLocal(date: Date): string {
  const local = new Date(date.getTime() - date.getTimezoneOffset() * 60_000)
  return local.toISOString().slice(0, 16)
}

export function toIso(local: string): string | null {
  if (!local) return null
  const date = new Date(local)
  return Number.isNaN(date.getTime()) ? null : date.toISOString()
}
